var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"menu-wrapper"},_vm._l((_vm.filteredItems),function(item,index){return _c('li',{key:index,on:{"click":_vm.emitClose}},[_c('NavItemSquare',{attrs:{"item":item}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }